import React from 'react'
import {  Link } from "react-router-dom";
import FormCntl from './FormCntrl'
import Footer from './components/footer'
import { FaFacebook, FaTwitter, FaYoutube } from 'react-icons/fa';
    function ContactPAge(){
        return(
            <>
             <section class="intro-single">
            <div class="container">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="title-single-box">
                    <h1 class="title-single">Contact US</h1>
                    <span class="color-text-a">  
                    Contact Nature Hearing Aid Service
 now and send in this form below to get your questions answered.
</span>
                  </div>
                </div>
               
              </div>
            </div>
            
          </section>
          <section class="contact">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="contact-map box">
            <div id="map" class="contact-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15553.820565498592!2d77.5996032!3d12.9427019!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc493a1a934006e5!2sNATURE%20HEARING%20AID%20SERVICE%20AND%20PRODUCTION%20LAB-HEARING%20AID%20REPAIR%20AND%20SERVICES%20IN%20LAKKASANDRA!5e0!3m2!1sen!2sin!4v1584861347054!5m2!1sen!2sin" className="google-map" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="col-sm-12 section-t8">
          <div class="row">
            <div class="col-md-7">
              <FormCntl/>
            </div>
            <div class="col-md-5 section-md-t3">
              <div class="icon-box section-b2">
                <div class="icon-box-icon">
                  <span class="ion-ios-paper-plane"></span>
                </div>
                <div class="icon-box-content table-cell">
                  <div class="icon-box-title">
                    <h4 class="icon-title">Say Hello</h4>
                  </div>
                  <div class="icon-box-content">
                    <p class="mb-1">Email.
                      <span class="color-a">sures.p3@gmail.com</span>
                    </p>
                    <p class="mb-1">Phone.
                      <span class="color-a">+91 990 292 8259</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="icon-box section-b2">
                <div class="icon-box-icon">
                  <span class="ion-ios-pin"></span>
                </div>
                <div class="icon-box-content table-cell">
                  <div class="icon-box-title">
                    <h4 class="icon-title">Find us in</h4>
                  </div>
                  <div class="icon-box-content">
                    <p class="mb-1">
                    #20/17, 16th Cross, Ganesh Temple Road,  
                    Lakkasandra, Bangalore-30.
                    </p>
                  </div>
                </div>
              </div>
              <div class="icon-box">
                <div class="icon-box-icon">
                  <span class="ion-ios-redo"></span>
                </div>
                <div class="icon-box-content table-cell">
                  <div class="icon-box-title">
                    <h4 class="icon-title">Social networks</h4>
                  </div>
                  <div class="icon-box-content">
                    <div class="socials-footer">
                      <ul class="list-inline">
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <FaFacebook/>
                            
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <FaTwitter/>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                           <FaYoutube/>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <i class="fa fa-pinterest-p" aria-hidden="true"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a href="#" class="link-one">
                            <i class="fa fa-dribbble" aria-hidden="true"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <Footer/>
           </>
    )
        }
export default ContactPAge